import { render, staticRenderFns } from "./NarrativeBuilderSearch.vue?vue&type=template&id=ecc71bce&scoped=true&"
import script from "./NarrativeBuilderSearch.vue?vue&type=script&lang=js&"
export * from "./NarrativeBuilderSearch.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeBuilderSearch.vue?vue&type=style&index=0&id=ecc71bce&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc71bce",
  null
  
)

export default component.exports